import React from 'react'
import PropTypes from 'prop-types'
import {Field, reduxForm} from 'redux-form'
import {RFSelectInput} from '../../fields/SelectInput'
import {RFTextInput} from '../../fields/TextInput'
import {RFTextArea} from '../../fields/TextArea'
import {RFIntlTelInput} from '../../fields/IntlTelInput/IntlTelInput'
import {RFMultiCheckbox} from '../../fields/MultiCheckbox'
import {RFDropdownTextInput} from '../../fields/DropdownTextInput'
import validator from 'validator'
import './OAuthApplicationForm.css'
import _ from 'lodash'

const cannotEmptyError = 'cannot be empty'
const shortDescriptionLengthError = 'must be 90 - 150 characters'
const longDescriptionLengthError = 'must be 150 - 400 characters'

const FORM_STATES = {
  CREDENTIALS: 'credentials',
  SCOPES: 'scopes',
  APP_INFORMATION: 'app_information',
  SCREENSHOTS: 'screenshots'
}

const validate = (values) => {
  const errors = {}

  if (!values.name) {
    errors.name = cannotEmptyError
  } else if (values.name.length > 40) {
    errors.name = 'max 40 characters'
  }

  if (!values.category) {
    errors.category = cannotEmptyError
  }

  if (!values.redirect_uri) {
    errors.redirect_uri = cannotEmptyError
  } else if (!validator.isURL(values.redirect_uri)) {
    errors.redirect_uri = 'invalid url'
  }

  if (!values.website) {
    errors.website = cannotEmptyError
  } else if (!validator.isURL(values.website, {protocols: ['http', 'https'], require_protocol: true, require_host: true})) {
    errors.website = 'invalid website'
  }

  if (!values.short_description) {
    errors.short_description = cannotEmptyError
  } else if (values.short_description.length < 90 || values.short_description.length > 150) {
    errors.short_description = shortDescriptionLengthError
  }

  if (!values.support_email) {
    errors.support_email = cannotEmptyError
  } else if (!validator.isEmail(values.support_email)) {
    errors.support_email = 'invalid email'
  }

  if (values.support_phone.length > 13) {
    errors.support_phone = 'max 13 characters'
  }

  if (!values.description) {
    errors.description = cannotEmptyError
  } else if (values.description.length < 150 || values.description.length > 400) {
    errors.description = longDescriptionLengthError
  }
  return errors
}

class OAuthApplicationForm extends React.Component {
  render () {
    return <form onSubmit={this.props.handleSubmit}>
      <div className='modal-body form-oauth-application-form__wrapper'>
        <div className='row'>
          {this._renderBreadcrumbs()}
          <div className='container-form'>
            {this._renderNavbar()}
            {this._renderCredentials()}
            {this._renderScopes()}
            {this._renderAppInformation()}
            {this._renderFooter()}
          </div>
        </div>
      </div>
    </form>
  }

  _renderFooter = () => {
    const {formState, errors} = this.props

    return <div className='row'>
      <div className='col-xs-12'>
        <hr />
        <div className='pull-right'>
          {formState === FORM_STATES.CREDENTIALS && <button
            type='button'
            className='btn btn-default mr-30px btn-stretch'
            onClick={this._cancel}
            disabled={this.props.disableSubmit}>Cancel</button>
          }
          {formState !== FORM_STATES.CREDENTIALS && <button
            type='button'
            className='btn btn-default mr-30px btn-stretch'
            onClick={this._back}
          >
            Back
          </button>}
          {formState !== FORM_STATES.APP_INFORMATION && <button
            type='button'
            className='btn btn-primary btn-stretch'
            onClick={this._next}
            disabled={!this._nextable()}
          >
            Next
          </button>}
          {formState === FORM_STATES.APP_INFORMATION && <button
            type='submit'
            className='btn btn-primary btn-stretch'
            disabled={Object.keys(errors).length > 0 || this.props.disableSubmit}
          >
            Save
          </button>}
        </div>
      </div>
    </div>
  }

  _renderBreadcrumbs = () => {
    const {app} = this.props
    // noinspection HtmlUnknownTarget
    return <ol className='breadcrumb-oauth breadcrumb'>
      <li><a onClick={this._breadcrumbClick}>Apps Dashboard</a></li>
      <li className='active'>
        {!!app.id && app.name}
        {!app.id && 'Create a new app'}
      </li>
    </ol>
  }

  _renderNavbar = () => {
    const {formState} = this.props

    return <nav className='navbar-oauth navbar navbar-default'>
      <div className='container-fluid'>
        <div className='collapse navbar-collapse'>
          <ul className='nav navbar-nav'>
            <li className={`${(formState === FORM_STATES.CREDENTIALS ? ' active' : ' ')}`}><a href='#' className='readonly'>Credentials</a></li>
            <li className={`${(formState === FORM_STATES.SCOPES ? ' active' : ' ')}`}><a href='#' className='readonly'>Scope</a></li>
            <li className={`${(formState === FORM_STATES.APP_INFORMATION ? ' active' : ' ')}`}><a href='#' className='readonly'>App Information</a></li>
          </ul>
        </div>
      </div>
    </nav>
  }

  _renderCredentials = () => {
    const {categories, formState} = this.props
    const styles = {}

    if (formState !== FORM_STATES.CREDENTIALS) {
      styles.display = 'none'
    }

    const filteredCategories = _.filter(categories, (d) => d.value === 'accounting' || d.value === 'e_commerce' || d.value === 'food_delivery' || d.value === 'analytics' || d.value === 'communication' || d.value === 'others' || d.value === 'online_ordering' || d.value === 'enterprise_resource_planning')
    return <div className='panel panel-default panel-oauth' style={styles}>
      <div className='panel-heading'>Credentials</div>
      <div className='panel-body'>
        <div className='form-group'>
          <div className='col-sm-12 no-padding'>
            <div className='form-group'>
              <label className='required'>App Name</label>
              <Field
                component={RFTextInput}
                name='name'
              />
            </div>
          </div>
          <div className='form-group'>
            <label className='required'>Category</label>
            <Field
              component={RFSelectInput}
              name='category'
            >
              <option value='' hidden>- Select Category - </option>
              {filteredCategories.map((c, idx) => <option value={c.value} key={idx}>{c.label}</option>)}
            </Field>
          </div>
          <div className='clearfix' />
        </div>

        <div className='form-group'>
          <label className='required'>Redirect URL</label>
          <Field
            component={RFDropdownTextInput}
            name='redirect_uri'
            className='form-control'
            placeholder={'Example: www.example.com/auth/moka/callback'}
            dropdownOptions={['https://', 'http://']}
          />
        </div>
        <div className='form-group'>
          <label>Application ID</label>
          <Field
            component={RFTextInput}
            name='uid'
            inputClassName='form-control cl-red'
            readOnly
          />
        </div>
        <div className='form-group'>
          <label>Secret</label>
          <Field
            component={RFTextInput}
            name='secret'
            readOnly
            inputClassName='form-control cl-red'
          />
        </div>
      </div>
    </div>
  }

  _renderScopes = () => {
    const {scopes, formState} = this.props
    const styles = {}
    const position = {
      profile: 0,
      report: 1,
      customer: 2,
      library: 3,
      transaction: 4
    }

    const orderedScopes = _.sortBy(scopes, (x) => position[x.value])
    if (formState !== FORM_STATES.SCOPES) {
      styles.display = 'none'
    }

    return <div className='panel panel-default panel-oauth' style={styles}>
      <div className='panel-heading'>Scope</div>
      <div className='panel-body'>
        <p className='mb-30px'>Select the necessary API permissions that you want to access from the merchant</p>
        <div className='form-group'>
          <Field
            component={RFMultiCheckbox}
            name='scopes'
            serializer={(values) => values.join(' ')}
            deserializer={(values) => values.split(' ')}
            options={orderedScopes}
          />
        </div>
      </div>
    </div>
  }

  _renderAppInformation = () => {
    const {formState} = this.props
    const styles = {}

    if (formState !== FORM_STATES.APP_INFORMATION) {
      styles.display = 'none'
    }

    return <div className='panel panel-default panel-oauth' style={styles}>
      <div className='panel-heading'>App Information</div>
      <div className='panel-body'>
        <div className='form-group'>
          <label className='required'>Short description</label>
          <Field
            component={RFTextArea}
            name='short_description'
          />
        </div>

        <div className='form-group'>
          <label className='required'>Long Description</label>
          <Field
            component={RFTextArea}
            name='description'
          />
        </div>

        <div className='form-group'>
          <label className='required'>Website</label>
          <Field
            component={RFDropdownTextInput}
            dropdownOptions={['https://', 'http://']}
            name='website'
          />
        </div>

        <div className='form-group'>
          <label className='required'>Email</label>
          <Field
            component={RFTextInput}
            name='support_email'
          />
        </div>

        <div className='form-group'>
          <label>Phone Number</label>
          <Field
            component={RFIntlTelInput}
            name='support_phone'
          />
        </div>

        <div className='form-group'>
          <label>Pricing</label>
          <Field
            component={RFTextInput}
            name='price'
          />
        </div>

      </div>
    </div>
  }

  _cancel = () => {
    this.props.onClickCancel()
  }

  _back = () => {
    this.props.onClickBack()
  }

  _next = () => {
    this.props.onClickNext()
  }

  _nextable = () => {
    const {formState, errors} = this.props
    if (formState === 'credentials') {
      return !errors.name && !errors.category && !errors.redirect_uri
    } else if (formState === 'app_information') {
      return !errors.website && !errors.short_description && !errors.support_email && !errors.description
    } else if (formState === 'screenshots') {
      return !errors.oauth_application_images
    } else {
      return true
    }
  }

  _breadcrumbClick = () => {
    this.props.onClickBreadcrumb()
  }
}

const mapForm = {
  form: 'app',
  validate,
  touchOnChange: true
}

OAuthApplicationForm.propTypes = {
  disableSubmit: PropTypes.bool,
  formState: PropTypes.string,
  onClickBack: PropTypes.func,
  onClickNext: PropTypes.func,
  onClickBreadcrumb: PropTypes.func
}

export default reduxForm(mapForm)(OAuthApplicationForm)



// WEBPACK FOOTER //
// app/javascript/components/forms/OAuthApplicationForm/OAuthApplicationForm.js